import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class MaturityRejectionRule {

  @JsonProperty()
  id: number = -1;

  @JsonProperty()
  maturity: string | undefined;

  @JsonProperty()
  brokerCode: string | undefined;

  @JsonProperty()
  contractList: string | undefined;

  @JsonProperty()
  exchangeCode: string | undefined;

  @JsonProperty()
  clearingHouse: string | undefined;

  @JsonProperty()
  source: string | undefined;

  @JsonProperty()
  contractListInclude: boolean = false;

  @JsonProperty()
  allOptions: boolean = false;

  @JsonProperty()
  allFutures: boolean = false;

  @JsonProperty()
  enabled: boolean = true;

  @JsonProperty()
  type: MaturityRejectionRule.MaturityRejectionRuleType = MaturityRejectionRule.MaturityRejectionRuleType.PENDING;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}

export module MaturityRejectionRule {
  export enum MaturityRejectionRuleType {
    PENDING = 'PENDING',
    WAIT_APPROVAL = 'WAIT_APPROVAL',
  }
}
